/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author        Afternet <info@afternet.gr>
 * @copyright   Afternet
 * @license        http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import {clearTabErrors, closeTabs, createTabsListingSpin, placeTabErrors, tab_button_animation} from "./front/_front";
import {
    removeFromProductListById,
    addToProductListById,
    replaceProductToList,
    cancelReplaceProductToList, getProductList, getUnitsData
} from "./front/_productListFuctions";

export default function step4Standard(){

    let xhr_calculateTotals = null;
    let xhr_calculateTotalsProductSingle = null;
    let delayedId_calculateTotalsProductSingle = null;

    $(document).on('click', '.js-product-toggle', function (e){
        e.stopPropagation();
        const _id = $(this).parents('.js-listItem').attr('data-productid',);
        if(!_id){return;}

        $('.js-listItem[data-productid="'+ _id +'"]').append('<div class="listItem__loader"><div class="kx-loader"></div></div>');

        if( $(this).parents('.js-listItem').attr('data-active') == 0 ){
            $(this).parents('.js-listItem').removeClass('deactivated');
            $(this).parents('.js-listItem').attr('data-active', 1);
            addToProductListById(_id);
        }else{
            $(this).parents('.js-listItem').addClass('deactivated');
            $(this).parents('.js-listItem').attr('data-active', 0);
            removeFromProductListById(_id);
        }

        if(xhr_calculateTotals != null){ xhr_calculateTotals.abort(); }
        setTimeout(function (){
            calculateTotals();
        },10);

    });

    $(document).on('change', '.js-tab-product-selection', function (e){
        e.stopPropagation();
        $('.js-productTabs-actions-error').hide();
        tab_button_animation();
    });

    $(document).on('click', '.js-productTabs-close', function (e){
        e.preventDefault();
        e.stopPropagation();

        const _slot = $(this).parents('.js-productTabs.opened').attr('data-slot');
        cancelReplaceProductToList(_slot);
        closeTabs();
    });

    $(document).on('click', '.js-productTabs-overlay', function (e){
        e.preventDefault();
        e.stopPropagation();

        const _slot = $(this).siblings('.js-productTabs.opened').attr('data-slot');
        cancelReplaceProductToList(_slot);
        closeTabs();
    });

    $(document).on('change', '.js-tabListProduct-variants *[name], .js-tabListProduct-qnt', function (e){
        e.preventDefault();
        e.stopPropagation();

        const _this = $(this);
        const _errorsBox = _this.parents('.js-productTabs-content').siblings('.js-productTabs-actions');

        //$(this).attr('data-product-attribute')      //number or undefined
        //$(this).attr('data-product-qty')            //1 or undefined

        let updateDelay = 30;
        if( $(this).attr('data-product-qty') == 1 ){
            updateDelay = 750;
        }

        let unitsData = getUnitsData();

        let formData = {};
        formData['serialized_data'] = $(this).parents('.js-tabListProduct').find('form:first').serialize();
        formData['id_product'] = $(this).parents('.js-tabListProduct').attr('data-productid');
        formData['qty'] = $(this).parents('.js-tabListProduct').find('.js-tabListProduct-qnt').val();
        formData['slot'] = $(this).parents('.js-productTabs').attr('data-slot');

        if (delayedId_calculateTotalsProductSingle) {
            clearTimeout(delayedId_calculateTotalsProductSingle);
        }

        if(!$('.js-tabListProduct[data-productid="'+ formData['id_product'] +'"]').find('.productTabsList__loader').length ){
            $('.js-tabListProduct[data-productid="'+ formData['id_product'] +'"]').append('<div class="productTabsList__loader"><div class="kx-loader"></div></div>');
        }

        $(this).parents('.js-tabListProduct').find('.js-tab-product-selection').prop("checked", true);

        delayedId_calculateTotalsProductSingle = setTimeout(()=>{
            xhr_calculateTotalsProductSingle = $.ajax({
                method: "POST",
                url: afpw_ajax_url,
                beforeSend: function () {
                    if(xhr_calculateTotalsProductSingle != null){ xhr_calculateTotalsProductSingle.abort(); }
                    if( typeof _this != 'undefined'){
                        clearTabErrors(_errorsBox);
                    }
                },
                cache: false,
                data: {
                    ajax: true,
                    action: 'calculateTotalsProductSingle',
                    hash: afpw_hash,
                    data: formData,
                    units: $.param(unitsData)
                },
            }).done(function (data, textStatus, jqXHR){
                try {
                    var obj = jQuery.parseJSON(data);
                    if (obj.status == 'success') {

                        const el = $('.js-tabListProduct[data-productid="'+ formData['id_product'] +'"]');

                        el.find('.js-tabListProduct-priceperkilo').html(obj.data.calculation.wizard_price_per_kg_formatted);
                        el.find('.js-tabListProduct-priceperkiloDefault').remove();
                        if(obj.data.calculation.wizard_has_sale == 1){
                            const _html = '<span class="text-12 color-90 js-tabListProduct-priceperkiloDefault line-through mr-2">' + obj.data.calculation.wizard_unit_price_tax_incl_no_discount_formatted + '</span>'
                            el.find('.js-price-box').prepend(_html);
                        }
                        el.find('.js-tabListProduct-consumption').html(obj.data.calculation.consumption_per_m2);
                        el.find('.js-tabListProduct-total').html(obj.data.calculation.wizard_total_cost_formatted);
                        el.find('.js-tabListProduct-amountperm').html(obj.data.calculation.wizard_cost_per_m2_formatted);
                        tab_button_animation();

                    } else {
                        if (typeof(obj.errors) != 'undefined' ) {
                            $.each(obj.errors, function(key,value) {
                                if(typeof _this != 'undefined'){
                                    placeTabErrors(_errorsBox, value);
                                }
                            });
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            }).fail(function(jqXHR, textStatus, errorThrown) {
                if(typeof _this != 'undefined'){
                    placeTabErrors(_errorsBox, 'Συνέβη ένα λάθος παρακαλώ δοκιμάστε αργότερα');
                }
                console.log(errorThrown);
            }).always(function() {
                xhr_calculateTotalsProductSingle = null;
                delayedId_calculateTotalsProductSingle = null;
                $('.productTabsList__loader').remove();
            });
        }, updateDelay);

    });

    $(document).on('click', '.js-productList-update', function (e){
        e.preventDefault();
        e.stopPropagation();

        if(xhr_calculateTotals != null){ xhr_calculateTotals.abort(); }

        $('.js-productTabs-actions-error').hide();
        const _this = $(this);
        const _el = $(this).parents('.js-productTabs-actions').siblings('.js-productTabs-content').find('.js-productTabs-tab.active').find('.js-tab-product-selection:checked').parents('.js-tabListProduct');
        const _slot = $(this).parents('.js-productTabs').attr('data-slot');

        if(_el.length == 0){
            $('.js-productTabs-actions-error').show();
        }else{
            replaceProductToList(_slot, _el);
            setTimeout(function (){
                calculateTotals(_this);
            },10);
        }
    });

    $(document).on('click', '.js-kx-add-to-cart', function (e){
        e.preventDefault();
        e.stopPropagation();

        if(window.List.length <= 0){
            if($('.js-kx-flow .alert').length){
                $('.js-kx-flow .alert').remove();
            }
            $('.js-kx-flow').append('<div class="alert alert-danger" role="alert">Η λίστα σας είναι άδεια</div>');
            return;
        }

        $.ajax({
            method: "POST",
            url: afpw_ajax_url,
            beforeSend: function () {
                if($('.js-kx-flow .alert').length){
                    $('.js-kx-flow .alert').remove();
                }
                $('#content').append('<div class="full-loader"><div class="kx-loader"></div></div>');
            },
            cache: false,
            data: {
                ajax: true,
                action: 'addProductsToCart',
                hash: afpw_hash,
                data: window.List
            },
        }).done(function (data, textStatus, jqXHR){
            try {
                var obj = jQuery.parseJSON(data);
                if (obj.status == 'success') {
                    if(obj.message){
                        $('.js-kx-flow').append('<div class="alert alert-success" role="alert">'+ obj.message +'</div>');
                    }
                    prestashop.emit('updateCart', {reason: {linkAction: 'refresh'}, resp: {}});
                    const _cart_url = prestashop.urls.pages.cart;
                    location.href = _cart_url;
                } else {
                    if (typeof(obj.errors) != 'undefined' ) {
                        $.each(obj.errors, function(key,value) {
                            $('.js-kx-flow').append('<div class="alert alert-danger" role="alert">'+ value +'</div>');
                        });
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }).fail(function(jqXHR, textStatus, errorThrown) {
            $('.js-kx-flow').append('<div class="alert alert-danger" role="alert">Συνέβη ένα λάθος παρακαλώ δοκιμάστε αργότερα</div>');
            console.log(errorThrown);
        }).always(function() {
            $('.full-loader').remove();
        });
    });

    function calculateTotals(_this){

        let unitsData = getUnitsData();
        let _errorsBox;
        if( typeof _this != 'undefined'){
            _errorsBox = _this.parents('.js-productTabs-actions');
        }

        xhr_calculateTotals = $.ajax({
            method: "POST",
            url: afpw_ajax_url,
            beforeSend: function () {
                if($('.js-kx-flow .alert').length){
                    $('.js-kx-flow .alert').remove();
                }
                if( typeof _this != 'undefined'){
                    clearTabErrors( _errorsBox );
                    _this.parents('.js-productTabs').append('<div class="full-loader"><div class="kx-loader"></div></div> ');
                }
                $('.js-kx-flow').append('<div class="kx-loader"></div>');
            },
            cache: false,
            data: {
                ajax: true,
                action: 'calculateTotals',
                hash: afpw_hash,
                data: window.List,
                units: $.param(unitsData)
            },
        }).done(function (data, textStatus, jqXHR){
            try {
                var obj = jQuery.parseJSON(data);
                if (obj.status == 'success') {

                    if($('.js-jobProductList').length){
                        $('.js-jobProductList').remove();
                    }
                    $('.js-kx-flow').append(obj.html);
                    createTabsListingSpin();
                    getProductList();

                } else {
                    //closeTabs();
                    if (typeof(obj.errors) != 'undefined' ) {
                        $.each(obj.errors, function(key,value) {
                            if(typeof _this != 'undefined'){
                                placeTabErrors(_errorsBox, value);
                            }
                        });
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }).fail(function(jqXHR, textStatus, errorThrown) {
            if(typeof _this != 'undefined'){
                placeTabErrors(_errorsBox, 'Συνέβη ένα λάθος παρακαλώ δοκιμάστε αργότερα');
            }
            console.log(errorThrown);
        }).always(function() {
            $('.kx-loader').remove();
        });

    }

}